import React from 'react';
import Checkbox from '../webcommon/common/checkbox/Checkbox';


const mappings = [
    {
        id: 'checkbox',
        title: '',
        width: 40,
        filterable: false,
        renderCell: row => (
            <Checkbox
                checked={ row.original.selected }
                onChange={ (checked) => {
                    row.column.getGridProps().setRowChecked(row.original.id, checked);
                } }
            />
        ),
        Header: header => (
            <Checkbox
                checked={ header.column.getGridProps().headerChecked }
                onChange={ (checked) => {
                    header.column.getGridProps().setHeaderChecked(checked);
                } }
            />
        )
    },
    {
        id: 'id',
        title: 'ReportId'
    },
    {
        id: 'fileName',
        title: 'FileName'
    },
    {
        id: 'runDate',
        title: 'RunDate'
    },
    {
        id: 'createdAt',
        title: 'DateCreated'        
    }
];

export default mappings;
